import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Util from 'lib/util';
import AppSelect from './select';

const styles = {};
/**
 * 单身自定义字段组件
 *
 * @param fieldSetting 自定义字段配置
 * @param isEdit 编辑状态用于弹窗编辑，非编辑状态用于明细显示
 * @param line   单身。非编辑时取单身数据
 * @param bodyCustData 自定义字段数据。编辑时使用此对象
 * @param setBodyCustData 自定义字段数据改变时回调
 *
 */
function BodyCustField(props) {
  const {
    classes,
    fieldSetting,
    line,
    bodyCustData,
    setBodyCustData,
    isEdit,
    isPurchase
  } = props;

  //文本|数字字段改变
  function handleChange(e) {
    let obj = {};
    obj[e.target.name] = e.target.value;
    setBodyCustData(Object.assign({}, bodyCustData, obj));
  }

  //下拉选单改变
  function handleSelectChange(e, fieldCode) {
    setBodyCustData(Object.assign({}, bodyCustData, { [fieldCode]: e.id }));
  }

  // 初始化默认预设值
  if (fieldSetting?.billType && isEdit) {
    fieldSetting.bodyCustList.forEach(field => {
      if (
        field.fieldValueType === 2 &&
        !field.presetValueList
          ?.map(row => row.id)
          .includes(bodyCustData[field.fieldCode])
      ) {
        // 预设值列表不包含当前字段值时，如果有默认值，设置为默认值。
        field.presetValueList.forEach(row => {
          if (row.isDefault === 1) {
            bodyCustData[field.fieldCode] = row.id;
          }
        });
      }
    });
  }

  let bodyCustList = fieldSetting.bodyCustList || [];

  if (Util.isEmpty(bodyCustList)) {
    return '';
  }

  if (!isEdit) {
    return (
      <ul className="field-list clearfix">
        {bodyCustList.map((field, index) => {
          return (
            <li key={index}>
              <span className="field-label">{field.transName}</span>
              <div className="field-value">{line[field.fieldCode] || '--'}</div>
              {/* {field.transName}：{line[field.fieldCode] || '--'} */}
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <div className="dialog order-detail-item">
      {bodyCustList.map((field, index) => {
        let edit =
          isEdit &&
          (isPurchase ? field.editFlag === 1 : field.needVendorInputFlag === 1);
        return (
          <div className="line" key={index}>
            <span className="order-detail-label">{field.transName}</span>
            {edit ? (
              <div className="field-body">
                {/* 数字 */}
                {field.fieldValueType === 0 && (
                  <input
                    type="number"
                    name={field.fieldCode}
                    value={bodyCustData[field.fieldCode] || ''}
                    onChange={handleChange}
                  />
                )}
                {/* 文本 */}
                {field.fieldValueType === 1 && (
                  <input
                    type="text"
                    name={field.fieldCode}
                    value={bodyCustData[field.fieldCode] || ''}
                    onChange={handleChange}
                  />
                )}
                {/* 预设值 */}
                {field.fieldValueType === 2 && (
                  <AppSelect
                    value={bodyCustData[field.fieldCode]}
                    options={field.presetValueList}
                    change={e => handleSelectChange(e, field.fieldCode)}
                  ></AppSelect>
                )}
                {/* 日期 与pc端不同，返回的不是时间戳，而是 YYYY-MM-DD */}
                {field.fieldValueType === 3 && (
                  <input
                    type="date"
                    name={field.fieldCode}
                    value={bodyCustData[field.fieldCode] || ''}
                    onChange={handleChange}
                  />
                )}
              </div>
            ) : (
              <div className="field-value">{line[field.fieldCode] || '--'}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}

BodyCustField.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(BodyCustField);
